import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'

export class Main extends AbstractView {
    constructor(domElementId) {
        return super(domElementId);
    }

    init() {
        const Voucher = () => import(/* webpackChunkName: "snippet-items-voucher" */ 'components/SnippetTemplate/Items/Voucher')
        new Vue({
            el: "#" + this.elemId,
            store,
            render: h => h(Voucher, {props: eval(this.elemId)})
        })
    }
}
